import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  saveConditionDataValue,
  saveConditionStateDescription,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectCentralSceneSubDeviceValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/WallmoteConditions/CentralSceneCondition/SelectCentralSceneSubDeviceValue/SelectCentralSceneSubDeviceValue'
import SelectCentralSceneSubDeviceValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/WallmoteConditions/CentralSceneCondition/SelectCentralSceneSubDeviceValue/SelectCentralSceneSubDeviceValue'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRouter,
} from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectCentralSceneSubDeviceValueIOS) : withStyles(SelectCentralSceneSubDeviceValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { isChangeSubDeviceStateMode } = state.scenes.currentSceneCreating
  const { wallmoteSettings, dataNumber } = state.scenes.currentSceneCreating.currentCondition
  return {
    isMobile,
    isChangeSubDeviceStateMode,
    wallmoteSettings,
    dataNumber,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionStateDescription,
  saveConditionDataValue,
}, dispatch)

enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectCentralSceneSubDeviceValueEnhanced = enhance

export default withRouter(SelectCentralSceneSubDeviceValueEnhanced)
